
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 .1C4.5.1.1 4.6.1 10s4.5 9.9 9.9 9.9 9.9-4.5 9.9-9.9S15.5.1 10 .1zm2.6 14c-.6.7-1.4 1.3-2.3 1.8-1.3.6-2.5.3-2.3-.8l1.3-5.6c.2-1.1-.7-1-1.8-.3h-.1v-.1c.6-.8 1.4-1.4 2.2-1.8 1.3-.6 2.5-.3 2.3.8l-1.3 5.6c-.2 1.1.7 1 1.8.3h.1c.1 0 .1.1.1.1zm0-9.3c-.2.6-.7 1-1.3 1H11c-.4-.1-.7-.6-.6-1 .2-.6.7-1 1.3-1h.3c.5.1.7.5.6 1z"}})])
          )
        }
      }
    